import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import Config from '../../config';
import { useAuthenticationStore } from '../../stores/authenticationStore';
import { useSessionStore } from '../../stores/sessionStore';
import Route from '../route';
import { subdomainParamKey } from './injectSubdomainAsRouteParam';

export default async function requireAuth(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void>
{
    // After login, always send to level select
    let redirectUrl = new URL(Route.LevelSelect.path, Config.CYBERSAFE_UI_BASE_URL);
    if(to.query['s'])
    {
        if(await useAuthenticationStore().authenticate('sso', to.query['s'] as string))
        {
            delete to.query['s'];
            return next({ ...to, replace: true});
        }
    }
    else if(to.query['t'])
    {
        if(await useAuthenticationStore().authenticate('vcr', to.query['t'] as string))
        {
            delete to.query['t']
            return next({ ...to, replace: true });
        }
    }
    else if(useSessionStore().token && await useSessionStore().resume())
    {
        return next();
    }

    window.location.href = new URL(`/join/${to.params[subdomainParamKey]}?redirect_url=${encodeURIComponent(redirectUrl.href)}`, Config.LOGIN_UI_BASE_URL).href;
}